export function navigateTo(url: string) {
  window.location.href = url;
}
